var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwitchCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#05cd78",
  fillRule: "evenodd",
  d: "M31.627 39.108H8.372a7.48 7.48 0 0 1-7.481-7.481V8.372A7.48 7.48 0 0 1 8.372.892h23.255a7.48 7.48 0 0 1 7.481 7.48v23.255a7.48 7.48 0 0 1-7.481 7.481"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.691 13.28h-2.988l-1.725-1.797h-5.656l-1.725 1.797H12.61c-1.041 0-1.885.804-1.885 1.797v10.781c0 .993.844 1.797 1.885 1.797h15.082c1.042 0 1.886-.804 1.886-1.797v-10.78c0-.994-.844-1.798-1.886-1.798zm-4.713 10.332v-2.246h-5.656v2.246l-3.299-3.144 3.3-3.145v2.246h5.655v-2.246l3.3 3.145z"
})));
export default SvgSwitchCamera;